export default __webpack_public_path__ + "static/media/five.3b8e2777.ogg";